import React from "react";

function HeartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 18 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.786 1.125C10.25 1.125 9 3.625 9 3.625s-1.25-2.5-3.786-2.5c-2.06 0-3.693 1.724-3.714 3.782-.043 4.27 3.388 7.307 7.149 9.86a.625.625 0 00.703 0c3.76-2.553 7.191-5.59 7.148-9.86-.02-2.058-1.653-3.782-3.714-3.782v0z"
      ></path>
    </svg>
  );
}

export default HeartIcon;
